import React from "react";
import { useNavigate } from "react-router-dom";
import { classNames } from "../../../../helpers/classNames";

const PaymentSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <div className="bg-white rounded-2xl shadow-lg p-8 text-center max-w-sm">
        <i
          className={classNames(
            "fa-fw fa-regular fa-check-circle",
            "text-6xl text-green-500 mx-auto mb-4"
          )}
        ></i>
        <h1 className="text-2xl font-bold text-deep-purple mb-2">
          Account added successfully!
        </h1>
        <p className="text-gray-600 mb-6">
          Thank you for add payment details informations. Your payment will
          successfully add on this details processed.
        </p>
        <button
          onClick={() => navigate("/")}
          className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;
